import React from "react";
import { Box, ButtonBase } from "@mui/material";
import { tokens } from "@/tokens";

interface SegmentedTabsProps {
  tabs: { id: string; label: string }[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

const SegmentedTabs: React.FC<SegmentedTabsProps> = ({ tabs, activeTab, onChange }) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        gap: 0.75,
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <ButtonBase
            key={tab.id}
            onClick={() => onChange(tab.id)}
            sx={{
              px: 2,
              py: 0.75,
              fontSize: tokens.fontSize.lg,
              fontWeight: tokens.fontWeight.semibold,
              borderRadius: tokens.radius.sm,
              border: "1px solid",
              transition: "all 150ms ease",
              ...(isActive
                ? {
                    borderColor: tokens.text.disabled,
                    color: tokens.text.primary,
                    bgcolor: tokens.bg.surface,
                  }
                : {
                    borderColor: "transparent",
                    color: tokens.text.secondary,
                    "&:hover": {
                      color: tokens.text.body,
                      bgcolor: tokens.bg.hover,
                    },
                  }),
            }}
          >
            {tab.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default SegmentedTabs;
